"use client";

import React from "react";
import { ConfigProvider } from "@arco-design/web-react";
import enUS from "@arco-design/web-react/es/locale/en-US";
import { QueryClient, QueryClientProvider } from "react-query";

interface RootProviderProps {
  children: React.ReactNode;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      refetchOnReconnect: false,
    },
  },
});

const RootProvider: React.FC<RootProviderProps> = ({ children }) => {
  return (
    <ConfigProvider locale={enUS}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ConfigProvider>
  );
};

export default RootProvider;
